
import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { BiDownload, BiShow, BiTrash } from 'react-icons/bi';
import { BsFileEarmarkText } from 'react-icons/bs';
import Utils from '../../core/utilities/Utils';

const FileListPanel = ({
	isSubmittedResponseView = false, index, files,
	onDownloadFile, onFilePreview, onReadOCRData, onRemoveFile
}) => {


	return (
		<div className='UploadFileNameView d-block'>
			{files?.length > 0 && files.map((fileDat, fileindex) => (

				<div key={fileindex} className='d-flex align-items-center mb-2 mt-2 gap-2 w-100'>
					<div className='UploadFileNameView_box py-2 px-3 border rounded bg-light flex-grow-1'>
						<span className='Up_fileName text-primary text-decoration-underline text-break cursor-pointer' onClick={() => onDownloadFile(fileDat.id)} key={fileindex}>
							{fileDat.fileName}
						</span>
					</div>

					<div className='d-flex gap-2 flex-shrink-0'>
						{Utils.isOfficeDocument(fileDat.fileName) ? (
							<OverlayTrigger
								placement="top"
								overlay={<Tooltip id={`tooltip-download-single-${index}-${fileindex}`}>Download</Tooltip>}
							>
								<span className='upload_Download cursor-pointer text-primary p-1' onClick={() => onDownloadFile(fileDat.id)}>
									<BiDownload />
								</span>
							</OverlayTrigger>
						) : (
							<OverlayTrigger
								placement="top"
								overlay={<Tooltip id={`tooltip-preview-single-${index}-${fileindex}`}>Preview File</Tooltip>}
							>
								<span className='upload_Preview cursor-pointer text-primary p-1' onClick={() => onFilePreview(fileDat.id, fileDat.fileName)}>
									<BiShow />
								</span>
							</OverlayTrigger>
						)}
						{/* <OverlayTrigger
							placement="top"
							overlay={<Tooltip id={`tooltip-ocr-single-${index}-${fileindex}`}>Read Data</Tooltip>}
						>
							<span className='upload_OCR cursor-pointer text-info p-1' onClick={() => onReadOCRData(fileDat.id)}>
								<BsFileEarmarkText />
							</span>
						</OverlayTrigger> */}
						{
							!isSubmittedResponseView &&
							<OverlayTrigger
								placement="top"
								overlay={<Tooltip id={`tooltip-delete-single-${index}-${fileindex}`}>Delete File</Tooltip>}
							>
								<span className='upload_Delete cursor-pointer text-danger p-1' onClick={() => onRemoveFile(fileDat.id, fileindex, fileDat.fileName)}>
									<BiTrash />
								</span>
							</OverlayTrigger>
						}
					</div>
				</div>
			))
			}
		</div>
	)
}


export default FileListPanel;
